import React, { Component } from "react";
import PropTypes from 'prop-types';
import {CheckmarkIcon} from '~/assets/svg'

class InterestCarousel extends Component {

  render() {
    return (
      <div className="carousel-wrapper">
        <h3>Which Types of Classes Interest You?</h3>
        <div className="interest-carousel">
          {this.props.interests.map( interest => {
            return <div key={interest.gist.id} 
              className="interest-box" 
              onClick={() => this.props.onSelect(interest)}>
              <img src={interest.gist.images['_1x1'].url} />
              {this.props.selectedInterests.indexOf(interest) >= 0 && <CheckmarkIcon className="selected-check"/>}
              <div className="interest-title">{interest.gist.title}</div>
            </div>
          })}
        </div>
      </div>
    );
  }
}

InterestCarousel.propTypes = {
  interests: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
};

export default InterestCarousel;
